import { render, staticRenderFns } from "./DynamicsChart.vue?vue&type=template&id=6296264b&scoped=true&"
import script from "./DynamicsChart.vue?vue&type=script&lang=js&"
export * from "./DynamicsChart.vue?vue&type=script&lang=js&"
import style0 from "./DynamicsChart.vue?vue&type=style&index=0&id=6296264b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296264b",
  null
  
)

export default component.exports